import type { FC } from 'react';
import React from 'react';

import { PaginationContext } from '../use-pagination';

interface IPaginationProvider {
    pagination: {
        addPage: () => number;
        isLastPage: boolean;
        nextPage: () => void;
        page: number;
        prevPage: () => void;
    };
}

export const PaginationProvider: FC<React.PropsWithChildren<IPaginationProvider>> = ({
    children,
    pagination: { addPage, isLastPage, nextPage, page, prevPage },
}) => (
    <PaginationContext.Provider value={{ addPage, nextPage, prevPage, page, isLastPage }}>
        {children}
    </PaginationContext.Provider>
);
